import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'

import SimpleTable from 'components/table/SimpleTable'
import SimpleTableDeleteDialog from 'components/table/SimpleTableDeleteDialog'
import SimpleTableHeader from 'components/table/SimpleTableHeader'
import SimpleTableActions from 'components/table/SimpleTableActions'

import settings from 'settings'
import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import quoteActions from 'store/modules/quote'

import numberUtils from 'shared/src/utils/number'

const AddIcon = settings.icons.add
const EditIcon = settings.icons.edit
const DeleteIcon = settings.icons.delete

const useStyles = makeStyles(theme => ({
  
}))

const QuoteList = ({

}) => {

  const classes = useStyles()
  const dispatch = useDispatch()

  const quotes = useSelector(selectors.quote.collection.list)
  const clients = useSelector(selectors.client.collection.entities)
  const currency = useSelector(selectors.project.currency)

  const [ deleteConfirmOpen, setDeleteConfirmOpen ] = useState(false)
  const [ deleteConfirmItem, setDeleteConfirmItem ] = useState(null)

  const onAdd = () => dispatch(routerActions.navigateTo('quote.create'))
  const onEdit = (id) => dispatch(routerActions.navigateTo('quote.edit.folder.tasks', { id, folderid: 'root' }))
  const onDelete = (id) => dispatch(quoteActions.delete(id))

  const openDeleteDialog = (item) => {
    setDeleteConfirmOpen(true)
    setDeleteConfirmItem(item)
  }

  const closeDeleteDialog = (item) => {
    setDeleteConfirmOpen(false)
    setDeleteConfirmItem(null)
  }


  const fields =[{
    title: 'Created',
    name: 'created',
  },{
    title: 'Name',
    name: 'name',
    width: '400px',
  },{
    title: 'Client',
    name: 'client',
  },{
    title: 'Type',
    name: 'type',
  },{
    title: 'Total',
    name: 'total',
  }]

  const data = quotes.map((quote, index) => {
    const client = clients[quote.client]
    const totals = quote.meta.totals || {}
    return {
      id: quote.id,
      name: quote.name,
      client: client ? client.name : '',
      created: new Date(quote.created_at).toLocaleString(),
      type: quote.meta.type,
      total: `${currency} ${numberUtils.twoDp(totals.grandTotal || 0, true, true)}`,
    }
  })

  const addButton = (
    <Button 
      className={classes.button} 
      variant="contained"
      color="secondary"
      onClick={ onAdd }
    >
      Add 
      <AddIcon />
    </Button>
  )

  const actions = [{
    title: 'Delete',
    icon: DeleteIcon,
    handler: (item) => openDeleteDialog(item),
  }, {
    title: 'Edit',
    icon: EditIcon,
    handler: (item) => onEdit(item.id),
  }]

  return (
    <div>
      <SimpleTableHeader
        title='Quotes'
        getActions={ () => addButton }
      />
      <SimpleTable
        data={ data }
        fields={ fields }
        getActions={ (item) => (
          <SimpleTableActions
            item={ item }
            actions={ actions }
          />
        )}
      />
      <SimpleTableDeleteDialog
        open={ deleteConfirmOpen }
        title={ deleteConfirmItem ? `the ${deleteConfirmItem.name} quote` : null }
        onCancel={ () => closeDeleteDialog() }
        onConfirm={ () => {
          closeDeleteDialog()
          onDelete(deleteConfirmItem.id)
        }}
      />
    </div>
  )
}

export default QuoteList

